import React from "react";
import { Progress, Tooltip } from "antd";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import { MAX_PROFICIENCY } from "../../GroupSkillsProficiencyV2.constants";
import {
  ProficiencyCellStyled,
  ProficiencyVisualizerStyled,
  BarWrapperStyled,
  BarLabelStyled,
  PointerRowStyled,
  RequiredIndicatorStyled,
  RequiredCaretIconStyled,
  RequiredValueStyled,
  ProficiencyBtnStyled,
} from "./ProficiencyBar.styles";
import { SB_COLORS } from "theme/SbThemeV2";

const BAR_TRAIL_STYLE = { trail: { stroke: SB_COLORS.secondary } };

const CURRENT_DOT = "#007bff";
const REQUIRED_DOT = SB_COLORS.primary;

const ProficiencyBar = ({ skill, index, onProficiencyChange }) => {
  const currentPct = (skill.current_proficiency / MAX_PROFICIENCY) * 100;
  const requiredPct = (skill.required_proficiency / MAX_PROFICIENCY) * 100;

  const tooltipTitle = (
    <div>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
        <span style={{ width: 10, height: 10, borderRadius: "50%", background: CURRENT_DOT, display: "inline-block", flexShrink: 0 }} />
        <span>Current Proficiency: <strong>{skill.current_proficiency ?? "--"}</strong></span>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <span style={{ width: 10, height: 10, borderRadius: "50%", background: REQUIRED_DOT, display: "inline-block", flexShrink: 0 }} />
        <span>Required Proficiency: <strong>{skill.required_proficiency ?? "--"}</strong></span>
      </div>
    </div>
  );

  return (
    // Flex props: align-items + gap. styled adds only padding.
    <ProficiencyCellStyled align="flex-start" gap={10}>
      <ProficiencyBtnStyled
        disabled
        onClick={() => onProficiencyChange(index, -1)}
        aria-label="Decrease required proficiency"
      >
        <MinusOutlined />
      </ProficiencyBtnStyled>

      {/* Flex prop: vertical (column direction). styled adds flex:1 + min-width:0. */}
      <Tooltip title={tooltipTitle} placement="top">
        <ProficiencyVisualizerStyled vertical flex="1">
          <BarWrapperStyled>
            <Progress
              percent={currentPct}
              strokeColor="#007bff"
              showInfo={false}
              strokeLinecap="round"
              size={["100%", 22]}
              styles={BAR_TRAIL_STYLE}
            />
            {skill.current_proficiency > 0 && (
              <BarLabelStyled $left={`${currentPct}%`}>
                {skill.current_proficiency}
              </BarLabelStyled>
            )}
          </BarWrapperStyled>

          <PointerRowStyled>
            <RequiredIndicatorStyled $pct={requiredPct} vertical align="center" gap={1}>
              <RequiredCaretIconStyled />
              <RequiredValueStyled>{skill.required_proficiency}</RequiredValueStyled>
            </RequiredIndicatorStyled>
          </PointerRowStyled>
        </ProficiencyVisualizerStyled>
      </Tooltip>

      <ProficiencyBtnStyled
        disabled={skill.required_proficiency >= MAX_PROFICIENCY}
        onClick={() => onProficiencyChange(index, +1)}
        aria-label="Increase required proficiency"
      >
        <PlusOutlined />
      </ProficiencyBtnStyled>
    </ProficiencyCellStyled>
  );
};

export default ProficiencyBar;
